import { render } from "./SpecialLecture.vue?vue&type=template&id=1924d2f6"
import script from "./SpecialLecture.vue?vue&type=script&lang=js"
export * from "./SpecialLecture.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__